import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { login } from '../../services/api';
import SiteFooter from '../SiteFooter';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password) return;
    setLoading(true);
    try {
      await login(username.trim(), password);
      navigate('/recruteur');
    } catch (err) {
      toast.error(err.response?.status === 429
        ? 'Trop de tentatives. Réessayez plus tard.'
        : 'Identifiants incorrects.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <main className="login-main">
        <form className="login-card" onSubmit={handleSubmit}>
          <h2>Administration ECV 2026</h2>
          <p className="login-subtitle">Recrutement des coordonnateurs provinciaux</p>
          <div className="form-group">
            <label htmlFor="username">Utilisateur</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Mot de passe</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>
          <button className="btn btn-primary" type="submit" disabled={loading || !username.trim() || !password}>
            {loading ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>
      </main>
      <SiteFooter />
    </div>
  );
};

export default Login;
